import { useEffect } from "react";
import { DEFAULT_LOCALE } from "../lib/i18n";

const CANONICAL_BASE = "https://vytaliboots.com";
export { CANONICAL_BASE };
const FALLBACKS = {
  home: "/brand/og-home.jpg",
  partner: "/brand/og-partner.jpg",
  event: "/brand/og-event.jpg",
  creator: "/brand/og-creator.jpg",
  challenge: "/brand/og-challenge.jpg",
};

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Absolute, publicly reachable share image. Backend-served media is proxied via the API host. */
function shareImage(image, kind) {
  const origin = typeof window !== "undefined" && window.location ? window.location.origin : CANONICAL_BASE;
  const fallback = `${origin}${FALLBACKS[kind] || FALLBACKS.home}`;
  if (!image) return fallback;
  if (image.startsWith("http")) return image;
  if (image.startsWith("/api/")) {
    const api = process.env.REACT_APP_BACKEND_URL;
    return api ? `${api}${image}` : fallback;
  }
  return `${origin}${image}`;
}

export const Seo = ({
  title,
  description,
  path = "/",
  image,
  kind = "home",
  type = "website",
  noindex = false,
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} — VytaliBoots` : "VytaliBoots — La mémoire vivante de Vytali";
    document.title = fullTitle;
    document.documentElement.lang = DEFAULT_LOCALE;
    const canonical = `${CANONICAL_BASE}${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    const img = shareImage(image, kind);
    const isFallback = img.includes("/brand/og-");
    setMeta("property", "og:image:width", isFallback ? "1200" : null);
    setMeta("property", "og:image:height", isFallback ? "630" : null);
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "VytaliBoots");
    setMeta("property", "og:locale", "fr_CA");
    setMeta("property", "og:image", img);
    setMeta("property", "og:image:alt", fullTitle);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
  }, [title, description, path, image, kind, type, noindex]);
  return null;
};

export default Seo;
